import { getInputFocusStyle } from '@fluentui/react';
export var TextFieldStyles = function (props) {
    var theme = props.theme, focused = props.focused, underlined = props.underlined, hasErrorMessage = props.hasErrorMessage;
    if (!theme) {
        throw new Error('theme is undefined or null in base TextField getStyles function.');
    }
    return {
        fieldGroup: [
            focused &&
                !underlined &&
                getInputFocusStyle(!hasErrorMessage ? theme.palette.themePrimary : theme.semanticColors.errorText, theme.effects.roundedCorner2)
        ]
    };
};
//# sourceMappingURL=TextField.styles.js.map